<template>
  <div class="mt-4">
    <div v-if="isLoading" class="text-center">
      <hr class="space space-sm">
      <loader size="128px"></loader>
      <p class="small muted pt-4">One moment...</p>
    </div>
    <div v-else-if="team && team.length">
      <div
        v-for="member in team"
        :key="member.id"
        class="d-flex"
      >
        <div class="pl-md-4">
          <div class="img-round">
            <img v-if="member.picture" :src="member.picture">
            <div class="placeholder" v-else>
              
            </div>
          </div>
        </div>
        <div class="flex-grow-1 pl-2">
          <h6 class="medium mb-0">{{ member.first_name }} {{ member.last_name }}</h6>
          <p class="small muted mb-0 lh1">{{ member.tagline }}</p>
          <p class="small">
            <a :href="'mailto:' + member.email">{{ member.email }}</a>
          </p>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <img src="/static/images/icons/team_empty.svg" alt="">
      <p class="regular pt-4">Team not assigned</p>
      <p class="lh15 small">
        We haven't formed a team for our project yet. Probably we're in the process of doing so, so hold tight.
      </p>
    </div>
    <div class="text-center py-4">
      <p>
        Have a question?
      </p>
      <a href="#" class="btn btn-outline-primary" @click.prevent="openChat()">
          Chat to us now
      </a>
      <hr class="space">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dashboard-team',
  props: ['id'],
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      project: state => state.projects.current,
      team: state => state.projects.team
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('LOAD_PROJECT_TEAM', this.id)
      .then((response) => {
        this.isLoading = false
      })
    if (!this.project || !this.project.id === this.id) {
      this.$store.dispatch('LOAD_PROJECT_BY_ID', this.id)
    } else {
      this.isLoading = this.team && this.team.length > 0
    }
  },
  methods: {
    openChat () {
      window.customerly.open()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
